// This file contains regex patterns used accross the application
import creditcardutils from 'creditcardutils';

// determine how many names are in a string (words separated by a space)
export const names = /([^\s])+([^\s])+/g;

// Source: https://stackoverflow.com/questions/354044/what-is-the-best-u-s-currency-regex
// currency, ex:   $12.32   12.3   5   3,435.43   $53,435   $6,233.23   $8,511.2
export const isCurrency = /^(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
export const validateCurrency = { pattern: { value: isCurrency } };

export const isInteger = /^[0-9]+$/;
export const validateInteger = { pattern: { value: isInteger } };

// starts with an integer (used for apt/unit entry detection, ie: '#123' vs '321')
export const startsWithInteger = /^[0-9]+$/;
export const validateStartsWithInteger = { pattern: { value: startsWithInteger } };

// for decimal numbers with 'commas' or 'dots'
export const isNumber = /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)\d+)?$/;
export const validateNumber = { pattern: { value: isInteger } };

export const isUrl = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
export const validateUrl = { pattern: { value: isUrl } };

export const isPhoneNumber = /(?:\d.*?){10,11}/;
export const validatePhoneNumber = { pattern: { value: isPhoneNumber } };

export const isFullName = /(\w.+\s).+/;
export const isCheckoutName = /^[a-z0-9]+$/;
export const validateFullName = { pattern: { value: isFullName } };
export const validateCheckoutName = { pattern: { value: isCheckoutName } };

export const priceValue = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
export const validatePrice = { validate: validPrice };
export function validPrice(price) {
  return !!(price && price.toString().match(priceValue));
}

export const quantityValue = /^\s*(?=.*[1-9])\d*\s*$/;
export const validateQuantity = { validate: validQuantity };
export function validQuantity(quantity) {
  return !!(quantity && quantity.toString().match(quantityValue));
}

export const creditCardNumberPattern = /^([\d#]{1,4})[ -]{0,1}([\d#]{1,4})[ -]{0,1}([\d#]{1,4})[ -]{0,1}([\d]{1,4})/;
export function validCreditCard(value) {
  return (
    value &&
    ((value.replace(/\D/g, '').length === 4 && ['X', '#'].includes(value.charAt(0)) && value.length > 13) ||
      creditcardutils.validateCardNumber(value))
  );
}
export const creditCardNumber = { validate: validCreditCard };
export const inputCreditCardNumberPattern = /([0-9# -]{1,19})/;

export const creditCardCvcPattern = /([\d]{3,4})/;

export const creditCardExpirationPattern = /^(\d{2})[\/\- ]{0,1}(\d{1,4})/;
export const creditCardExpiration = { pattern: { value: creditCardExpirationPattern } };
export function validCreditCardExpiration(expiration) {
  var valid = expiration && expiration.match(creditCardExpirationPattern);

  if(!valid){
    return false;
  }

  var today, someday;
  var [exMonth, exYear] = expiration.split('/');

  exYear = exYear.length === 2 ? '20' + exYear : exYear;
  today = new Date();
  someday = new Date();
  someday.setFullYear(exYear, exMonth, 1);

  return someday >= today;
}

export function validCvc(creditCard) {
  return (
    typeof creditCard.cvc !== 'undefined' &&
    (creditCard.cc_type === 'amex' ? creditCard.cvc.length === 4 : creditCard.cvc.length === 3)
  );
}
